import { Card, btnPrimary, inputStyle, labelStyle } from "../shared";

export function CompanyProfileSection({ companyProfile, setCompanyProfile, companyProfileSaved, logoSaved, saveCompanyProfile }) {
  const nextInvoiceNum = `${companyProfile.invoice_prefix || "INV"}-${String(companyProfile.invoice_counter || 1000).padStart(4, "0")}`;

  return (
    <Card style={{ marginBottom: 20 }}>
      <div style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 800, fontSize: 16, marginBottom: 6 }}>🏢 Company Profile</div>
      <div style={{ fontSize: 12, color: "#9B9690", marginBottom: 20 }}>Used on invoices, receipts, and tenant-facing documents.</div>
      <div className="app-grid-2" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20 }}>
        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          <div>
            <label style={labelStyle}>Company Logo</label>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              {companyProfile.logo_url && (
                <img src={companyProfile.logo_url} alt="Logo" style={{ width: 48, height: 48, objectFit: "contain", borderRadius: 8, border: "1px solid #e0dbd0", background: "#F5F1EA" }} />
              )}
              <input type="file" accept="image/*" onChange={e => setCompanyProfile(s => ({ ...s, logoFile: e.target.files[0] || null }))} style={{ ...inputStyle, padding: "7px 13px", cursor: "pointer", flex: 1 }} />
            </div>
            {logoSaved
              ? <div style={{ fontSize: 11, color: "#22c55e", marginTop: 4 }}>✅ Logo saved!</div>
              : companyProfile.logoFile && <div style={{ fontSize: 11, color: "#22c55e", marginTop: 4 }}>✅ {companyProfile.logoFile.name} — will upload on save</div>
            }
          </div>
          {[
            ["Company Name",           "company_name", "text",  "e.g. Gibbs Prodigy Group"],
            ["DBA (Doing Business As)", "dba",          "text",  "e.g. GPG Properties"],
            ["Contact Email",           "email",        "email", "invoices@example.com"],
            ["Contact Phone",           "phone",        "text",  "(555) 000-0000"],
            ["Business Address",        "address",      "text",  "123 Main St, Pittsburg, CA 94565"],
            ["Website",                 "website",      "url",   "https://example.com"],
          ].map(([lbl, key, type, ph]) => (
            <div key={key}>
              <label style={labelStyle}>{lbl}</label>
              <input type={type} placeholder={ph} value={companyProfile[key] || ""} onChange={e => setCompanyProfile(s => ({ ...s, [key]: e.target.value }))} style={inputStyle} />
            </div>
          ))}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
            <div>
              <label style={labelStyle}>Invoice Prefix</label>
              <input type="text" maxLength={8} placeholder="INV" value={companyProfile.invoice_prefix || ""} onChange={e => setCompanyProfile(s => ({ ...s, invoice_prefix: e.target.value.toUpperCase() }))} style={inputStyle} />
            </div>
            <div>
              <label style={labelStyle}>Next Invoice #</label>
              <div style={{ ...inputStyle, background: "#F5F1EA", color: "#9B9690", display: "flex", alignItems: "center" }}>{nextInvoiceNum}</div>
            </div>
          </div>
          <div>
            <label style={labelStyle}>Invoice Footer Text</label>
            <textarea value={companyProfile.invoice_footer || ""} onChange={e => setCompanyProfile(s => ({ ...s, invoice_footer: e.target.value }))} style={{ ...inputStyle, height: 64, resize: "vertical" }} placeholder="e.g. Thank you for your payment. Questions? Call (555) 000-0000." />
          </div>
        </div>

        <div>
          <label style={{ ...labelStyle, marginBottom: 10 }}>Invoice Preview</label>
          <div style={{ background: "#F5F1EA", border: "1px solid #e0dbd0", borderRadius: 12, padding: 20 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 14 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                {companyProfile.logo_url
                  ? <img src={companyProfile.logo_url} alt="Logo" style={{ width: 36, height: 36, objectFit: "contain", borderRadius: 6 }} />
                  : <div style={{ width: 36, height: 36, borderRadius: 6, background: "#163C2F", display: "flex", alignItems: "center", justifyContent: "center", color: "#7FB98E", fontFamily: "'Cormorant Garamond', serif", fontWeight: 700, fontSize: 14 }}>L</div>
                }
                <div>
                  <div style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 800, fontSize: 14, color: "#163C2F" }}>{companyProfile.company_name || "Your Company"}</div>
                  {companyProfile.dba     && <div style={{ fontSize: 10, color: "#9B9690" }}>DBA: {companyProfile.dba}</div>}
                  {companyProfile.address && <div style={{ fontSize: 10, color: "#9B9690" }}>{companyProfile.address}</div>}
                </div>
              </div>
              <div style={{ textAlign: "right" }}>
                <span style={{ background: "#22c55e22", color: "#16a34a", border: "1px solid #22c55e44", borderRadius: 6, padding: "2px 8px", fontSize: 10, fontWeight: 700 }}>PAID</span>
                <div style={{ fontSize: 10, color: "#9B9690", marginTop: 3 }}>{nextInvoiceNum}</div>
              </div>
            </div>
            <div style={{ height: 1, background: "#E8E4DC", marginBottom: 10 }} />
            {[["Tenant","Jane Doe"],["Property","123 Main St"],["Amount Paid","$1,200"],["Payment Date", new Date().toISOString().slice(0,10)]].map(([k,v]) => (
              <div key={k} style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
                <span style={{ fontSize: 10, color: "#9B9690" }}>{k}</span>
                <span style={{ fontSize: 11, fontWeight: 600, color: "#163C2F" }}>{v}</span>
              </div>
            ))}
            {companyProfile.invoice_footer && (
              <>
                <div style={{ height: 1, background: "#E8E4DC", margin: "10px 0 8px" }} />
                <div style={{ fontSize: 9, color: "#9B9690", fontStyle: "italic" }}>{companyProfile.invoice_footer}</div>
              </>
            )}
            <div style={{ height: 1, background: "#E8E4DC", margin: "10px 0 8px" }} />
            <div style={{ fontSize: 9, color: "#9B9690" }}>
              {companyProfile.email || "email@example.com"}
              {companyProfile.phone   ? ` · ${companyProfile.phone}`   : ""}
              {companyProfile.website ? ` · ${companyProfile.website}` : ""}
            </div>
          </div>
        </div>
      </div>

      <div style={{ marginTop: 20, display: "flex", gap: 12, alignItems: "center" }}>
        <button style={btnPrimary} onClick={saveCompanyProfile}>Save Company Profile</button>
        {companyProfileSaved && <span style={{ color: "#22c55e", fontSize: 13, fontWeight: 600 }}>✅ Saved!</span>}
      </div>
    </Card>
  );
}
